import Portfolio from './portfolio';
import './App.css';

function App() {
  return <Portfolio />;
}

export default App;
